<template>
  <div class="printingPage equipment">
    <div v-if="empty === 'false'">
      <BreadCrumb />
      <div class="content">
        <div class="content-box">
          <div class="box">
            <div
              class="equipmentBox"
              v-loading="$store.state.request.requestCount"
            >
              <a
                href="https://www.foxitsoftware.cn/dayin/help.html"
                target="_blank"
                class="button"
              >
                <i></i>
                <span>添加设备</span>
              </a>
              <div class="tip">
                <p>
                  分享的打印机（在线{{ onlineDevices.length }}台，共{{
                    equipmentOptions.length
                  }}台）
                </p>
                <i @click="equipmentListFn"></i>
              </div>
              <ul class="printerList">
                <li
                  :class="{
                    printerItem: true,
                    active: index === curIndex
                  }"
                  v-for="(item, index) in equipmentOptions"
                  :key="index"
                  @click="changeType(index)"
                >
                  <div class="listLeft">
                    <Printer :item="item" />
                    <div>
                      <p class="model">
                        {{ item.equipmentAlias || item.equipmentName }}
                      </p>
                      <p class="parameter">
                        <span v-if="item.newPaperSize">{{
                          item.newPaperSize.join("/")
                        }}</span>
                        <span class="dividingline">|</span>
                        <span>{{ item.singleDoubleSides }}</span>
                        <span class="dividingline">|</span>
                        <span>{{ item.colorMode }}</span>
                      </p>
                    </div>
                  </div>
                  <div class="listRight">
                    <div
                      v-if="item.defaultFlag === 'yes'"
                      :class="{ 'statu default': item.defaultFlag === 'yes' }"
                    >
                      默认
                    </div>
                    <div
                      v-if="item.equipmentStatus === 'offline'"
                      :class="{
                        'statu offLine': item.equipmentStatus === 'offline'
                      }"
                    >
                      离线
                    </div>
                    <div
                      :class="{
                        more: true
                      }"
                    >
                      <div class="sign">
                        <span>•••</span>
                      </div>
                      <ul class="moreSubmenu">
                        <li class="delete" @click="cancelShare(item)">
                          <div>
                            <i></i>
                          </div>
                          <span>取消分享</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="information">
              <div class="deviceInformation">
                <h3>设备信息</h3>
                <div class="table InformationTable">
                  <div class="line collapseLine">
                    <el-collapse v-model="printerActiveNames">
                      <el-collapse-item>
                        <template slot="title">
                          <div class="collapse_box">
                            <p class="label">打印机名称</p>
                            <p class="deviceName">
                              {{ equipmentParameters.equipmentAlias }}
                            </p>
                          </div>
                        </template>
                        <div class="collapseItem">
                          <p class="label">
                            设置备注名，方便快速找到对应的打印机
                          </p>
                          <el-input
                            v-model.trim="inputValue"
                            placeholder="请输入打印机名称"
                            maxlength="18"
                          ></el-input>
                          <div class="collapseItemButtonBox">
                            <el-button
                              @click="closeCollapse('printerActiveNames')"
                              >取消</el-button
                            >
                            <el-button
                              type="primary"
                              @click="modifyPrinterNameFn"
                              >确定</el-button
                            >
                          </div>
                        </div>
                      </el-collapse-item>
                    </el-collapse>
                  </div>
                  <div class="line">
                    <div>
                      <p class="label">打印机型号</p>
                      <p class="deviceName">
                        {{ equipmentParameters.equipmentModel }}
                      </p>
                    </div>
                  </div>
                </div>
                <h3 class="columnTitle userBox">
                  已加入分享的人
                  <span class="manageBtn" @click="toggleUserEdit">{{
                    !userEdit ? "管理" : "取消"
                  }}</span>
                </h3>
                <div class="table">
                  <div
                    class="line"
                    v-if="equipmentParameters.equipmentFrom !== '1'"
                  >
                    <ul class="shareUser">
                      <li
                        v-for="(item, index) in bindUsers"
                        :key="item.id"
                        class="item"
                      >
                        <div>
                          <img
                            :class="{
                              round: true,
                              opacity: item.bindStatus === '1'
                            }"
                            :src="
                              item.bindAvatar ||
                                require('@/assets/img/avatar48.png')
                            "
                            alt=""
                          />
                          <span
                            v-if="userEdit"
                            class="removeBtn"
                            @click="removeUser(item)"
                            >-</span
                          >
                        </div>
                        <span class="des">{{ item.bindNickName }}</span>
                      </li>
                      <li class="item cursor" @click="createShare">
                        <div class="round">
                          <i class="el-icon-plus" />
                        </div>
                        <span class="des">邀请好友</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="empty" v-else-if="empty === 'really'">
      <div>
        <img src="~@/assets/img/deviceManagement/empty.png" alt="" />
        <p>还未分享任何打印机设备</p>
        <a @click="toDeviceList" class="add">去分享</a>
      </div>
    </div>
    <ShareDialog
      @clearShareInfo="clearShareInfo"
      ref="shareDialog"
      :shareInfo="shareInfo"
      :printer="equipmentParameters"
    />
  </div>
</template>

<script type="text/javascript">
import Printer from "common/components/web/Printer.vue";
import { mapState } from "vuex";
import { REQUEST_URL, APP_KEY } from "const";
import {
  findSharePrintEquipmentList,
  modifyPrinterName,
  createShare,
  cancelShare,
  bindEquipmentList,
  deleteBindEquipment
} from "api/api";
import BreadCrumb from "cpnts/web/BreadCrumb.vue";
import ShareDialog from "../device/components/shareDialog.vue";
import store from "../../../store";
import { signIn } from '../../../utils/utils';
export default {
  name: "DeviceManagement",
  components: {
    BreadCrumb,
    ShareDialog,
    Printer
  },
  data() {
    return {
      btnLoaindg: false,
      empty: null, //是否空态
      inputValue: "", //打印机别名
      mode: null, //打印方式默认选中
      paperSizeOptions: ["A3", "A4", "A5"], //纸张大小数组
      checkedPaperSizeOptions: [], //默认选中的纸张
      printerActiveNames: [], //打印折叠面板
      activeNames: [], //打印配置折叠面板
      equipmentOptions: {}, //打印机列表
      curIndex: 0, //默认选择默认的打印机
      equipmentParameters: {}, //设备参数
      printEquipmentOptionsList: [], //设备默认打印参数配置
      onlineDevices: [], //在线设备数量
      shareInfo: null, // 分享码
      bindUsers: [],
      userEdit: false
    };
  },
  computed: {
    ...mapState("user", ["userInfo", "accessToken"])
  },
  methods: {
    init() {
      this.equipmentListFn(); //获取设备列表
    },
    //获取设备列表
    equipmentListFn() {
      this.onlineDevices = [];
      findSharePrintEquipmentList().then(res => {
        const { code, data = [] } = res;
        if (code === 0) {
          if (data.length) {
            this.empty = "false";
            this.equipmentOptions = data;
            this.equipmentParameters = data[0];
            //默认选项数据
            for (let i in this.equipmentOptions) {
              //默认选中默认打印机
              if (this.equipmentOptions[i].defaultFlag === "yes") {
                this.changeType(Number(i));
              }
              //统计在线设备数
              if (this.equipmentOptions[i].equipmentStatus === "online") {
                this.onlineDevices.push(this.equipmentOptions[i]);
              }
              let arr = [];
              let list = this.equipmentOptions[i].printEquipmentOptionsList;
              //列表参数规格
              for (let term of list) {
                if (term.optionKey === "paperSize") {
                  arr.push(term);
                  this.equipmentOptions[i].newPaperSize = arr.map(item => {
                    return item.optionValue;
                  });
                } else if (term.optionKey === "colorMode") {
                  let isExist = this.equipmentOptions[i].colorMode;
                  this.equipmentOptions[i].colorMode = isExist
                    ? (isExist += `/${term.optionName}`)
                    : term.optionName;
                } else if (term.optionKey === "singleDoubleSides") {
                  let isExist = this.equipmentOptions[i].singleDoubleSides;
                  this.equipmentOptions[i].singleDoubleSides = isExist
                    ? (isExist += `/${term.optionName}`)
                    : term.optionName;
                }
              }
            }
            //无默认时打印机时，选择第一台
            let isDefaultFlag = this.equipmentOptions.every(item => {
              return item.defaultFlag === "no";
            });
            if (isDefaultFlag) {
              if (this.curIndex > 0) {
                this.changeType(this.curIndex);
              } else {
                this.changeType(0); //否则默认选中第一台
              }
            }
          } else {
            // this.empty = true;
            this.empty = "really";
          }
        }
        //无权限用户
        if (code === 401) {
          this.empty = "really";
        }
      });
    },
    clearShareInfo() {
      this.shareInfo = null;
    },
    toggleUserEdit() {
      if (!this.userEdit && (!this.bindUsers || this.bindUsers.length === 0)) {
        return this.$alert({
          description: "当前无加入分享的好友"
        });
      }
      this.userEdit = !this.userEdit;
    },
    toDeviceList() {
      this.$router.push({
        name: "device"
      });
    },
    removeUser(user) {
      this.$alert({
        description: "删除成员后，成员将无法继续使用该打印机，是否删除？",
        showCancelButton: true,
        callback: () => {
          deleteBindEquipment([user.id]).then(({ code, data }) => {
            if (code === 0) {
              //设置成功
              this.$message.success("删除成员成功");
              this.equipmentListFn();
            }
          });
        }
      });
    },
    //打印机切换
    changeType(index) {
      bindEquipmentList({ equipmentId: this.equipmentOptions[index].id }).then(
        res => {
          this.bindUsers = res.data || [];
        }
      );
      this.curIndex = index;
      //切换设备信息
      this.equipmentParameters = this.equipmentOptions[index];
      if (this.equipmentParameters.equipmentFrom === "1") {
        this.activeNames = [];
      }
      this.checkedPaperSizeOptions = [];
      //查询使用范围
      // this.usersPermittedFn();
      //快印码启用切换
      this.switchValue =
        this.equipmentOptions[index].qrStatus === "enabled" ? true : false;
      this.switchClose =
        this.equipmentOptions[index].qrStatus === "enabled" ? false : true;
      for (let item of this.equipmentParameters.printEquipmentOptionsList) {
        switch (item.optionKey) {
          case "paperSize":
            this.checkedPaperSizeOptions.push(item.optionValue);
            break;
          case "colorMode":
            this.pattern = item.optionValue;
            break;
          case "singleDoubleSides":
            this.mode = item.optionValue;
            break;
          default:
            break;
        }
      }
      //查看当前设备是否启用且有快印码
      if (this.equipmentOptions[index].qrStatus === "enabled") {
        let token = "";
        let codeSrc = `${REQUEST_URL}/printEquipment/getQrCode/${
          this.equipmentOptions[index].id
        }?id=${
          this.equipmentOptions[index].id
        }&appKey=${APP_KEY}&r=${Math.random()}`;
        let downSrc = `${REQUEST_URL}/printEquipment/getQrCode/${
          this.equipmentOptions[index].id
        }?download=true&appKey=${APP_KEY}&r=${Math.random()}`;
        if (localStorage.getItem("token")) {
          token = JSON.parse(localStorage.getItem("token")).token;
          this.codeSrc = codeSrc += `&token=${token}`;
          this.downSrc = downSrc += `&token=${token}`;
        }
        if (localStorage.getItem("iam")) {
          const accessToken = store.state.user.accessToken;
          this.codeSrc = codeSrc += `&accessToken=${accessToken}`;
          this.downSrc = downSrc += `&accessToken=${accessToken}`;
        }
      } else {
        this.codeSrc = null;
      }
    },
    //修改打印机备注名称
    modifyPrinterNameFn() {
      if (this.inputValue.length) {
        modifyPrinterName({
          id: this.equipmentParameters.id,
          equipmentAlias: this.inputValue
        })
          .then(res => {
            const { code } = res;
            if (code === 0) {
              this.equipmentListFn(); //更新设备列表
              this.printerActiveNames = []; //折叠面板收起
              this.inputValue = null; //清空输入值
            }
          })
          .catch();
      } else {
        this.printerActiveNames = []; //折叠面板收起
      }
    },
    // 创建分享
    createShare() {
      this.$refs.shareDialog.visible = true;
      createShare({ equipmentId: this.equipmentParameters.id })
        .then(res => {
          if (res.code === 0) {
            this.$message.success("创建分享成功");
            this.shareInfo = res.data;
          } else {
            this.$refs.shareDialog.visible = false;
            switch (res.code) {
              case 60010:
                return this.$alert({
                  description: "该打印机绑定人数达上限，请升级为云办公企业账号",
                  callback() {
                    window.open(
                      "https://www.foxitsoftware.cn/dayin/help_m4523.html"
                    );
                  }
                });
              default:
                this.$alert({
                  description: "创建分享失败，请重试"
                });
            }
          }
        })
        .catch(() => {
          this.$alert("创建分享失败，请重试");
        });
    },
    cancelShare(item) {
      this.$alert({
        description: "取消分享后，被分享用户将无法继续使用该打印机，是否取消？",
        showCancelButton: true,
        callback: () => {
          cancelShare({ equipmentId: item.id }).then(({ code, data }) => {
            if (code === 0) {
              //设置成功
              this.$message.success("取消分享成功");
              this.equipmentListFn();
            }
          });
        }
      });
    },
    //关闭折叠面板
    closeCollapse(data) {
      this[data] = [];
    },
    //开始打印
    updatePrintingList() {
      this.showPrintOptions = false; //关闭弹窗
    }
  },
  mounted() {
    if (!this.userInfo) return signIn();
    this.init();
  }
};
</script>

<style lang="scss" scoped>
@import "./myShare.scss";
.equipment {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  .empty {
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(90vh - 60px);
    a {
      text-align: center;
    }
    p {
      color: #424242;
      font-size: 16px;
      margin: 30px 0 25px 0;
      text-align: left;
      padding: 0 0 0 22px;
    }
    .add {
      display: block;
      width: 120px;
      height: 40px;
      line-height: 40px;
      border-radius: 20px;
      border: solid 1px $theme-color;
      color: $theme-color;
      font-size: 14px;
      margin: 0 0 0 49px;
      cursor: pointer;
      &:hover {
        background: $theme-color;
        color: #ffffff;
      }
    }
  }
  .content {
    width: 100%;
    background-color: #ffffff;
    border-radius: 4px;
    .content-box {
      background-color: #ffffff;
    }
    .box {
      display: flex;
      width: 100%;
      min-height: calc(100vh - 120px);
      .equipmentBox {
        min-height: 100%;
        padding: 30px 10px 30px 30px;
        border-right: 1px solid #eeeeee;
        .button {
          width: 420px;
          height: 48px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 2px;
          border: solid 1px #dddddd;
          color: #666666;
          font-size: 14px;
          cursor: pointer;
          i {
            display: block;
            background: url("~~@/assets/img/deviceManagement/add.png") no-repeat
              center;
            margin: 0 6px 0 0;
            width: 16px;
            height: 16px;
          }
          &:hover {
            border: dashed 1px $theme-color;
            color: $theme-color;
            i {
              background: url("~~@/assets/img/deviceManagement/add_h.png")
                no-repeat center;
            }
          }
        }
        .tip {
          color: #424242;
          font-size: 14px;
          text-align: left;
          margin: 30px 0 14px;
          display: flex;
          i {
            display: block;
            background: url("~~@/assets/img/deviceManagement/refresh.png")
              no-repeat center;
            width: 13px;
            height: 13px;
            cursor: pointer;
            &:hover {
              display: block;
              background: url("~~@/assets/img/deviceManagement/refresh_h.png")
                no-repeat center;
              width: 13px;
              height: 13px;
            }
          }
        }
        .printerList {
          width: 430px;
          height: calc(100% - 100px);
          overflow: auto;
          li.printerItem {
            position: relative;
            height: 64px;
            border-radius: 4px;
            padding: 0 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            text-align: left;
            margin: 8px 10px 0 0;
            cursor: pointer;
          }
          li.active {
            background-color: #f8f8f8;
          }
          .listLeft {
            display: flex;
            align-items: center;
            .icon {
              margin: 0 14px 0 0;
            }
            .model {
              color: #424242;
              font-size: 14px;
              width: 178px;
              height: 18px;
              line-height: 18px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .parameter {
              color: #999999;
              font-size: 12px;
              margin: 9px 0 0 0;
              .dividingline {
                margin: 0 7px;
                color: #dddddd;
              }
              span {
                &:last-child {
                  .dividingline {
                    display: none;
                  }
                }
              }
            }
          }
          .listRight {
            display: flex;
            align-items: center;
            .more {
              position: relative;
              .sign {
                width: 40px;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                &:hover {
                  span {
                    color: $theme-color;
                  }
                }
                span {
                  color: #999999;
                  font-size: 16px;
                }
              }
              &:hover {
                background-color: #f0f0f0;
                .moreSubmenu {
                  display: block;
                }
              }
              .moreSubmenu {
                display: none;
                position: absolute;
                width: 113px;
                left: -72px;
                z-index: 10;
                background-color: #ffffff;
                box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
                border-radius: 2px;
                padding: 12px 0;
                box-sizing: border-box;
                li {
                  background-color: #ffffff;
                  height: 32px;
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
                  padding: 0 0 0 15px;
                  margin: 0;
                  cursor: pointer;

                  div {
                    height: 32px;
                    display: flex;
                    align-items: center;
                  }
                  span {
                    font-size: 14px;
                    height: 32px;
                    display: flex;
                    align-items: center;
                  }
                }
                .default div {
                  margin: 0 6px 0 0;
                  i {
                    display: block;
                    background: url("~~@/assets/img/deviceManagement/set.png")
                      no-repeat center;
                    width: 15px;
                    height: 13px;
                  }
                }
                .default {
                  &:hover {
                    background-color: #f8f8f8;
                    color: $theme-color;
                    i {
                      background: url("~~@/assets/img/deviceManagement/set_h.png")
                        no-repeat center;
                    }
                  }
                }
                .delete div {
                  margin: 0 6px 0 0;
                  i {
                    display: block;
                    background: url("~~@/assets/img/deviceManagement/delete.png")
                      no-repeat center;
                    width: 15px;
                    height: 13px;
                  }
                }
                .delete {
                  color: #f44141;
                  &:hover {
                    background-color: #f8f8f8;
                    color: #f44141;
                  }
                }
              }
            }
            .statu {
              width: 48px;
              height: 22px;
              line-height: 22px;
              border-radius: 11px;
              color: #ffffff;
              font-size: 12px;
              text-align: center;
              margin: 0 8px 0 0;
            }
            .default {
              background-color: #bbb9b7;
            }
            .offLine {
              background-color: #ff943e;
            }
          }
        }
      }
      .information {
        flex: 1;
        padding: 30px;
        // margin: 0 0 0 464px;
        .deviceInformation {
          ::v-deep .el-button.el-button--default:hover {
            color: #1a4bff;
            background-color: #eaeeff;
          }
          h3 {
            color: #212121;
            font-size: 18px;
            text-align: left;
          }
          .columnTitle {
            margin: 0 0 15px 0;
          }
          .userBox {
            display: flex;
            justify-content: space-between;
            .manageBtn {
              display: block;
              width: 55px;
              height: 24px;
              border-radius: 11px;
              border: solid 1px $theme-color;
              line-height: 22px;
              color: $theme-color;
              text-align: center;
              font-size: 12px;
              cursor: pointer;
              &:hover {
                color: white;
                background-color: $theme-color;
              }
              &:active {
                color: white;
                background-color: $theme-color-active;
              }
            }
          }
          .InformationTable {
            margin: 18px 0 28px;
          }
          .table {
            border-radius: 4px;
            border: solid 1px #eeeeee;
            border-bottom: none;
            .line {
              display: flex;
              align-items: center;
              padding: 18px 20px;
              text-align: left;
              box-sizing: border-box;
              border-bottom: 1px solid #eeeeee;
              .label {
                color: #999999;
                font-size: 14px;
              }
              .deviceName {
                color: #424242;
                font-size: 14px;
                margin: 10px 0 0 0;
                .dividingline {
                  margin: 0 7px;
                  color: #dddddd;
                }
              }
            }
            .collapseLine {
              padding: 14px 20px;
            }
          }
        }
      }
    }
  }
}
.top {
  height: 63px;
  display: flex;
  align-items: center;
  background-color: #f8f8f8;
}

.itemTip {
  display: inline-block;
  background: url("~~@/assets/img/deviceManagement/tipIcon.png") no-repeat
    center;
  width: 12px;
  height: 12px;
  margin: 0 0 0 4px;
  vertical-align: middle;
  &:hover {
    background: url("~~@/assets/img/deviceManagement/tipIcon_h.png") no-repeat
      center;
  }
}

.newTag {
  background-color: #ff5c5c;
  height: 16px;
  font-size: 14px;
  line-height: 16px;
  color: white;
  border-radius: 6px 6px 6px 0;
  padding: 0 7px;
  margin-left: 6px;
}

.collapse_box {
  display: flex;
  flex-direction: column;
  .label,
  .deviceName {
    line-height: 14px;
  }
}

ul::-webkit-scrollbar {
  width: 5px;
  height: 10px;
}
ul::-webkit-scrollbar-track {
  background: #ffffff;
  border-radius: 2px;
}
ul::-webkit-scrollbar-thumb {
  background: #bfbfbf;
  border-radius: 10px;
}
ul::-webkit-scrollbar-thumb:hover {
  background: #bfbfbf;
}

.cursor {
  cursor: pointer;
}

.shareUser {
  width: 100%;
  display: flex;
  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 12px;
    position: relative;
    .des {
      width: 70px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 12px;
      line-height: 24px;
      text-align: center;
      letter-spacing: 0px;
      color: #666666;
    }
    .round {
      width: 40px;
      height: 40px;
      background-color: #dddddd;
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-size: 20px;
      overflow: hidden;
    }
    .opacity {
      opacity: 0.35;
    }
    .removeBtn {
      position: absolute;
      right: 10px;
      top: -6px;
      width: 13px;
      height: 13px;
      line-height: 10px;
      font-size: 18px;
      text-align: center;
      background-color: $theme-color;
      border-radius: 7px;
      color: white;
      cursor: pointer;
      user-select: none;
      &:hover {
        background-color: $theme-color-hover;
      }
      &:active {
        background-color: $theme-color-active;
      }
    }
  }
}
</style>
